/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

import * as S from '../common/styled';

export const CommentButton = styled.a`
  display: inline-block;
  text-decoration: none;

  ${S.BaseButton}
`;
